var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMissingImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 60,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h90v60H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M0 0h90v60H0z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "84.378%",
    y1: "26.068%",
    x2: "16.498%",
    y2: "79.972%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#748993",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38474D",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#c)",
    opacity: 0.509,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 32c-17.863-5.428-36.403-9.862-36.403-9.862S.983 26.232-17 31.868c.206-1.328.74-2.587 1.585-3.551l13.887-15.834C-.326 11.113 2.032 10 3.734 10h31.512c1.704 0 4.059 1.112 5.262 2.483l13.888 15.834c.873.996 1.413 2.307 1.604 3.683zM16 83l-32.169-45.804A6.149 6.149 0 01-17 35.49c16.01-2.282 28.85-3.47 28.85-3.47 2.292-.228 4.15 1.577 4.15 4.033V83zm39.183-45.82L23 83V36.048c0-2.456 1.86-4.262 4.154-4.027 0 0 12.897 1.216 28.846 3.5a6.14 6.14 0 01-.817 1.658z",
    fill: "#38474D",
    fillRule: "nonzero",
    opacity: 0.075,
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("text", {
    opacity: 0.393,
    mask: "url(#d)",
    fontFamily: "MuseoSans-300, Museo Sans",
    fontSize: 5,
    fontWeight: 300,
    fill: "#38474D"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 45,
    y: 51
  }, "THUMBNAIL NOT "), /*#__PURE__*/React.createElement("tspan", {
    x: 60.933,
    y: 56
  }, "AVAILABLE")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissingImage);
export default __webpack_public_path__ + "static/media/missing_image.fa4d13a2f8549a28af2c6bdc9fbd6d55.svg";
export { ForwardRef as ReactComponent };